import { makeStyles } from "tss-react/mui"
import { useEffect, useState } from "react"
import {
  API_STATUSES,
  BRIGHTEDGE,
  LINE_OF_BUSINESS,
} from "constants-lib/common"
import { Link } from "component-lib/Base/components/Link/Link"

const useStyles = makeStyles()((theme) => ({
  container: {
    display: `flex`,
    fontFamily: `Maax-Bold`,
    gap: `5.625rem`,
    "& span": {
      color: `${theme.palette.common.white} !important`,
      fontSize: `1.25rem !important`,
      marginBottom: `2rem`,
    },
  },
  link: {
    gap: `6.25rem`,
    display: `flex`,
    fontFamily: `Maax`,
    "& a": {
      color: `${theme.palette.common.white} !important`,
      fontSize: `1.25rem !important`,
      lineHeight: `1.9rem !important`,
    },
    "& a:hover": {
      color: `${theme.palette.common.white} !important`,
    },
  },
}))

const BrightEdge = ({
  brightEdgeServletData: {
    brightedgeErrorMessageState = "",
    brightedgeServletErrorMessage = {},
  },
}) => {
  const { classes } = useStyles({})
  const [data, setData] = useState({})

  useEffect(() => {
    if (brightedgeErrorMessageState === API_STATUSES.FULFILLED) {
      setData(brightedgeServletErrorMessage)
    }
  }, [brightedgeErrorMessageState])

  return data?.UrlPattern === LINE_OF_BUSINESS.commercial ||
    data?.UrlPattern === LINE_OF_BUSINESS.residential ? (
    <div className={classes.container} data-testid="BrightEdge">
      <span>{BRIGHTEDGE.INTEREST}</span>
      <div className={classes.link}>
        {data?.bodyString?.links?.map((item) => (
          <Link key={item.anchor_text} href={item.url} isExternalLink>
            {item.anchor_text}
          </Link>
        ))}
      </div>
    </div>
  ) : null
}

// // Note: React 19 no-longer supports propTypes. Leaving this for reference.
// BrightEdgeLegacy.propTypes = {
//   brightEdgeServletData: PropTypes.string,
// }

// // Note: React 19 no-longer supports defaultProps. Leaving this for reference.
// BrightEdgeLegacy.defaultProps = {
//   // this default value is incorrect, brightEdgeServletData is an object
//   brightEdgeServletData: "",
// }

export default BrightEdge
